import { useEffect, useState } from "react";
import axios from "axios";
import RoomCard from "@/components/RoomCard";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Rooms() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    axios.get(`${API}/rooms`).then((r) => setRooms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-32 pb-24 md:pt-40">
      <Seo
        title="Rooms — Premium Room & Premium Twin Room"
        description="Fourteen quietly considered rooms at Hotel Azulo Inn, Safdarjung Enclave. Choose between our Premium Room (king bed) and Premium Twin Room (king or two single beds)."
        path="/rooms"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="overline">The Collection</div>
          <h1 className="mt-6 font-serif text-5xl md:text-7xl leading-[0.98] text-ink-900 max-w-3xl">
            Fourteen rooms.
            <span className="italic text-sage-dark"> Two categories.</span>
          </h1>
          <p className="mt-8 max-w-xl text-ink-700 leading-relaxed">
            Each room at Hotel Azulo Inn is well-finished and air-conditioned, with a flat-screen
            television, a coffee machine, and high-speed Wi-Fi. Premium Rooms have a king bed;
            Premium Twin Rooms can be configured with a king bed or two single beds — the rest is identical.
          </p>
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-8">
        {rooms.map((r) => (
          <RoomCard key={r.slug} room={r} size="lg" />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 text-sm text-ink-600 italic">
        Tariffs are dynamic and change with season and occupancy. Our reservations desk will share
        current rates for your dates by email or phone.
      </div>
    </div>
  );
}
